// @mui
import { Box, BoxProps, Stack } from '@mui/material';
// hooks
import useResponsive from '@Hooks/shared/useResponsive';
// config
import { HEADER, NAV } from '@configs/config-global';
// components
import { useSettingsContext } from '@Components/settings';
import AccountDropDown from '@Features/account/AccountDropdown';
import RgsDropdown from '@Features/account/RgsDropdown';
import GamesDropdown from '@Features/account/GamesDropdown';

// ----------------------------------------------------------------------

const SPACING = 8;

export default function Main({ children, sx, ...other }: BoxProps) {
  const { themeLayout } = useSettingsContext();

  const isNavHorizontal = themeLayout === 'horizontal';

  const isNavMini = themeLayout === 'mini';

  const isDesktop = useResponsive('up', 'lg');

  if (isNavHorizontal) {
    return (
      <Box
        component="main"
        sx={{
          pt: `${HEADER.H_MOBILE + SPACING}px`,
          pb: `${HEADER.H_MOBILE + SPACING}px`,
          ...(isDesktop && {
            px: 2,
            pt: `${HEADER.H_DASHBOARD_DESKTOP + 80}px`,
            pb: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
          }),
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        position: 'relative',
        flexGrow: 1,
        py: `${HEADER.H_MOBILE + SPACING}px`,
        ...(isDesktop && {
          px: 2,
          pt: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
          pb: 0,
          width: `calc(100% - ${NAV.W_DASHBOARD}px)`,
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_DASHBOARD_MINI}px)`,
          }),
        }),
        ...sx,
      }}
      {...other}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        height="32px"
        sx={{ marginTop: '-50px', marginBottom: '20px' }}
      >
        <Stack direction="row" gap={2} alignItems="center" sx={{ width: '100%', height: '100%' }}>
          <RgsDropdown />
          <GamesDropdown />
        </Stack>
        <AccountDropDown />
      </Stack>
      {children}
    </Box>
  );
}
